import { Translation, Language } from '../../utils/translation';

Translation.register(Language.English, {
    TopQueries_title: 'People also searched for',
});
